import { FC } from 'react'
import clsx from 'clsx'
import { IconSvg } from 'components/common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IconButtonProps {
	icon: string
	onClick?: () => void
	title?: string
	disabled?: boolean
	className?: string
	loading?: boolean
}

const IconButton: FC<IconButtonProps> = ({ icon, onClick, title, disabled, className, loading }) => (
	<button
		type="button"
		className={clsx('transition-all duration-300 flex items-center justify-center rounded-full', className)}
		onClick={onClick}
		title={title}
		disabled={disabled || loading}
	>
		<IconSvg icon={icon} className={clsx({ hidden: loading })} />
		<FontAwesomeIcon icon={['fas', 'spinner']} size="lg" spin className={clsx({ hidden: !loading })} />
	</button>
)

export default IconButton
